import React, { useContext } from 'react'
import { UserContext } from '../../App';
import { Navigate, Route, Routes } from 'react-router-dom';
import { RoleKey } from '../../JS/RoleType';
import { SchoolDashBoard } from '../SchoolDashboard';
import { ManageTicket } from '../ManageTicket';
import RepairDetails from '../../Components/RepairDetails';
import { ManageDeviceIndex } from '../ManageDevice';
import { IndexUsers } from '../ManageUsers';
import { ImportExport } from '../ImportExport';
import { SchoolReports } from '../SchoolReports';
import { ShipDevices } from '../ShipDevices';
import HelpdeskIndex from '../Helpdesk';
import { MaintenanceSupportTicket } from '../SupportTicket/Maintenance';
import { ManageParts } from '../ManagePart';
import MassTicket from '../MassTicket';
import Outgoingbatches from '../ShipDevices/Outgoingbatches';
import { AddUpdate } from '../ManageDevice/addupdate';
import { UsersAddUpdate } from '../ManageUsers/addupdate';
import { DeviceAllocate } from '../DeviceAllocation';
import ManageSoftware from '../ManageSoftware';
import { SchoolInvoice } from '../SchoolBilling';
import { TechnologySupportTicket } from '../SupportTicket/Technology';
import { ErrorPage } from '../404Error';
import TicketAssignment from '../TicketAssignments';
import RolesIndex from '../Roles';
import SchoolProfile from '../SchoolProfile';
import DeviceCustomField from '../CustomField/Index';
import Helpdeskrequest from '../Helpdesk/Helpdeskrequest';
import HelpdeskTicket from '../Helpdesk/HelpdeskTicket';
import ErrorLogsPage from '../ErrorPage/ErrorLogsPage';
import ShowInvoice from '../SchoolBilling/ShowInvoice';
import TicketHistoryPage from '../Billingandtickets/TicketHistoryPage';
import CoveragePurchased from '../ParentalCoverage/CoveragePurchased';
import Notification from '../Notification';
import { FaqIndex } from '../FAQ';
import { Setting } from '../Setting';
import { CreateTicket } from '../CreateTicket';
import CloseTicketInvoice from '../../Components/CloseTicketInvoice';
import History from '../ParentalCoverage/History';
import AddSetup from '../ParentalCoverage/AddSetup';
import { Setup } from '../ParentalCoverage/setup';
import HdticketAssignments from '../Helpdesk/HdticketAssignments';
import PreviousAudits from '../InventoryAudit/PreviousAudits';
import InventoryAudit from '../InventoryAudit';
import UsersGroup from '../UsersGroup';
import Building from '../Building';
import { StaffMemberIndex } from '../StaffMember';
import { IndexSchools } from '../Schools';
import { SchoolTickets } from '../SchoolTickets';
import { IncomingBatches } from '../IncomingBatch';
import { AdminBilling } from '../Billingandtickets/AdminBilling';
import { Technician } from '../Technician';
import { DomainIndex } from '../Domain';
import { Locations } from '../Locations';
import { MasterInventory } from '../MasterInventory';
import { PricingActivation } from '../ParentalCoverage/PricingActivation';
import MassDownload from '../MassDownload';
import RepairTypes from '../RepairTypes';
import CurrentPurchases from '../ParentalCoverage/CurrentPurchases';
import ResellerGroup from '../Reseller/ResellerGroup';
import ResellerStaff from '../Reseller/ResellerStaff';
import { Admindashboard } from '../AdminDashboard/admindashboard';
import { ReportsIndex } from '../AdminReports';
import PartsOrders from '../PartsOrder/PartsOrder';
import RocketCustomers from '../RocketCustomers/Index';
import Expresstechform from '../Enterprise/Expresstechform';
import DeviceModels from '../DeviceModels/Index';

const componentMap = {
    "school-dashboard": SchoolDashBoard,
    "admin-dashboard": Admindashboard,
    "admin-custom-field": DeviceCustomField,
    "device-models": DeviceModels,
    "manage-tickets": ManageTicket,
    "repair-details": RepairDetails,
    "manage-device": ManageDeviceIndex,
    "manage-parts": ManageParts,
    "users": IndexUsers,
    "import-export": ImportExport,
    "school-reports": SchoolReports,
    "admin-reports": ReportsIndex,
    "ship-devices": ShipDevices,
    "helpdesk": HelpdeskIndex,
    "maintenance-support-tickets": MaintenanceSupportTicket,
    "mass-tickets": MassTicket,
    "outgoing-batches": Outgoingbatches,
    "addupdate-device": AddUpdate,
    "addupdate-users": UsersAddUpdate,
    "allocate-devices": DeviceAllocate,
    "manage-software": ManageSoftware,
    "school-invoice": SchoolInvoice,
    "technology-support-tickets": TechnologySupportTicket,
    "ticket-assignments": TicketAssignment,
    "staff-members": StaffMemberIndex,
    "building": Building,
    "users-groups": UsersGroup,
    "inventory-audit": InventoryAudit,
    "previous-audits": PreviousAudits,
    "helpdesk-ticket-assignments": HdticketAssignments,
    "setup": Setup,
    "add-setup": AddSetup,
    "club-history": History,
    "CloseTicketInvoice": CloseTicketInvoice,
    "create-ticket": CreateTicket,
    "setting": Setting,
    "faqs": FaqIndex,
    "notifications": Notification,
    "purchases": CoveragePurchased,
    "ticket-history": TicketHistoryPage,
    "generate-invoice": ShowInvoice,
    "error-logs-page": ErrorLogsPage,
    "add-helpdesk": HelpdeskTicket,
    "helpdesk-requests": Helpdeskrequest,
    "custom-field": DeviceCustomField,
    "device-models": DeviceModels,
    "school-profile": SchoolProfile,
    "roles": RolesIndex,
    "schools": IndexSchools,
    "school-tickets": SchoolTickets,
    "incoming-batches": IncomingBatches,
    "admin-invoice": AdminBilling,
    "technician": Technician,
    "domain": DomainIndex,
    "locations": Locations,
    "master-inventory": MasterInventory,
    "pricing-activation-process": PricingActivation,
    "bulk-downloads": MassDownload,
    "repair-types": RepairTypes,
    "current-purchases": CurrentPurchases,
    "reseller-group": ResellerGroup,
    "reseller-staff": ResellerStaff,
    "parts-orders": PartsOrders,
    "rocket-customers": RocketCustomers,
    'add-msp': Expresstechform
};
const staticRoutes = ["setting", "notifications", "CloseTicketInvoice", "school-profile", "error-logs-page", "rocket-customers"];


export default function CustomAccesses() {
    const { UserData, menuData } = useContext(UserContext);
    if (!menuData || menuData.length === 0) {
        return <div className='ps-3 pt-4 font-18'>Loading...</div>; // You can replace this with a spinner or skeleton UI
    }
    const routeDependencies = {
        "manage-tickets": ["repair-details", "create-ticket"],
        "school-tickets": ["repair-details", "create-ticket", "addupdate-device"],
        "manage-device": ["addupdate-device", "custom-field"],
        "users": ["addupdate-users"],
        "helpdesk": ["helpdesk-requests", "helpdesk-ticket-assignments", "add-helpdesk"],
        "parental-care": ["setup", "add-setup", "club-history"],
        "inventory-audit": ["previous-audits"],
        "school-invoice": ["generate-invoice"],
        "maintenance-support-tickets": ["ticket-assignments"],
        "technology-support-tickets": ["ticket-assignments"],
        "setup": ["add-setup"],
        "school-invoice": ["ticket-history"],
        "admin-invoice": ["ticket-history"],
        "pricing-activation-process": ["add-setup"],
        "reseller-group": ["add-msp"],
    };
    const getFilteredMenu = () => {
        switch (UserData.role) {
            case RoleKey.K12_REPAIR_TECH:
            case RoleKey.K12_LEAD_TECH:
                if (UserData.copyaccesstype) {
                    return menuData.filter(item => item.school_admin_flag == 2);
                } else {
                    return menuData.filter(item => item.school_admin_flag == 1);
                }
            default:
                return menuData;
        }
    };
    const getAccessibleRoutes = (menu) => {
        let allowedRoutes = new Set();
        let firstAccessibleRoute = null;

        menu.forEach(item => {
            if (item.href && componentMap[item.href]) {
                allowedRoutes.add(item.href);
                if (!firstAccessibleRoute) firstAccessibleRoute = item.href;

                if (routeDependencies[item.href]) {
                    routeDependencies[item.href].forEach(depRoute => allowedRoutes.add(depRoute));
                }
            }

            if (item.submenu) {
                let hasChild = false;

                item.submenu.forEach(subItem => {
                    if (subItem.href && componentMap[subItem.href]) {
                        allowedRoutes.add(subItem.href);
                        if (!firstAccessibleRoute) firstAccessibleRoute = subItem.href;
                        hasChild = true;

                        if (routeDependencies[subItem.href]) {
                            routeDependencies[subItem.href].forEach(depRoute => allowedRoutes.add(depRoute));
                        }
                    }
                });

                if (hasChild && item.href && componentMap[item.href]) {
                    allowedRoutes.add(item.href);
                    if (!firstAccessibleRoute) firstAccessibleRoute = item.href;
                }
            }
        });

        return { routes: Array.from(allowedRoutes), firstRoute: firstAccessibleRoute };
    };

    const { routes: accessibleRoutes, firstRoute } = getAccessibleRoutes(getFilteredMenu());
    const allRoutes = Array.from(new Set([...accessibleRoutes, ...staticRoutes]));
    return (
        <Routes>
            {firstRoute && <Route path="/" element={<Navigate to={`/${firstRoute}`} replace />} />}
            {allRoutes.map(route => (
                <Route key={route} path={`/${route}/*`} element={React.createElement(componentMap[route])} />
            ))}
            <Route path="*" element={<ErrorPage />} />
            <Route path="faqs" element={<FaqIndex />} />
        </Routes>
    )
}
